// extracted by mini-css-extract-plugin
module.exports = {"columns":"styles_columns__U43DV","column":"styles_column__KJH3E","columnWithDivider":"styles_columnWithDivider__PcfAF","buttonRow":"styles_buttonRow__TlotB"};